module.exports = __webpack_public_path__ + "static/media/card_bg_4.6284431d.png";